/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';

import Link from '../../components/Link';
import {clampLines} from '../../util';
import {useAnalytics} from '../../hooks';

const CoachCard = ({coach, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/coach/${coach.slug}`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'coaching', tag: tag.id, slug: coach.slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="block cursor-pointer py-4 px-5 border border-gray-200 rounded-lg hover:border-gray-300 transition duration-50"
    >
      {coach.Photo?.[0]?.url && (
      <div className="flex justify-between mb-5">
        <img
          className="w-10 h-10 rounded-full mr-4 object-cover"
          src={coach.Photo[0].url}
          alt={coach.Name}
          loading="lazy"
        />
        <div>
          <div className="text-gray-500 text-right">
            {coach.Title}
          </div>
        </div>
      </div>
      )}
      <Link href={url}>
        <h3 className="text-xl font-medium text-gray-900 mb-3">{coach.Name}</h3>
      </Link>
      <div
        className="text-sm text-gray-500"
        style={clampLines(2)}
      >
        {coach['Brief Bio']}
      </div>
    </div>
  );
};

export default CoachCard;
